function domainValidator(value = '') {
  let isValid

  const { path, createError } = this

  isValid =
    value.length === 0 ||
    value.match(
      /^(https?:\/\/)?(www\.)?[-а-яА-Яa-zA-Z0-9@%._+~#=]{1,256}\.[-а-яА-Яa-zA-Z0-9()]{1,6}\b([-а-яА-Яa-zA-Z0-9()@:%_+.~#?&/=]*)$/,
    )

  return (
    isValid ||
    createError({
      path,
      message: 'common::validation_messages.incorrect_url',
    })
  )
}

export default domainValidator
